import { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';

import { FHSimpleTable } from '../../../base';
import { assessmentHistoryDataTransformer } from '../utils';
import { history } from '../../../../helpers';
import { assessmentHistoryColumns, getHistoryTableOptions } from '../table-configs/';

import type { HistoricalDocuments } from '../../../../pages/constants';
import type { IClientAssessment } from '../../../../utils/types';

interface IAssessmentHistoryTableData {
  id?: number;
  client: string;
  assessment_id: string;
  status: string;
  start_date: string;
  time: string;
  duration: string;
}

interface IAssessmentHistoryTableProps {
  data: IClientAssessment[];
  documentType: HistoricalDocuments;
}

function AssessmentHistoryTable({ data = [], documentType }: IAssessmentHistoryTableProps) {
  const tableOptions = useMemo(() => {
    return {
      ...getHistoryTableOptions(documentType),
      onRowClick: (args: any) => {
        history.navigate(`/assessment-note/${args[0]}`);
      },
    };
  }, [documentType]);

  const [historyTableData, setHistoryTableData] = useState<IAssessmentHistoryTableData[]>([]);

  useEffect(() => {
    const transformedTableData = assessmentHistoryDataTransformer(data);
    setHistoryTableData(transformedTableData);
  }, [data]);

  return (
    <Box data-testid="historicalSNTable">
      <FHSimpleTable
        data={historyTableData}
        columnDefinitions={assessmentHistoryColumns}
        columnOptions={tableOptions}
      />
    </Box>
  );
}

export default AssessmentHistoryTable;
